import React, { useState, useEffect, useMemo } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-pink/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import * as Yup from 'yup';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import * as apicall from '../../components/Apicall';
import '../../App.css';
import './VendorForm.css';


// Names shown to the admin for the fields in the "Please fill" message.
const FIELD_LABELS = {
    vendorName: 'Vendor name', contactNumber: 'Contact', serviceType: 'Service', selectlocation: 'Service locations',
    country: 'Country', state: 'State', city: 'City', email: 'Email', address: 'Address',
    bankName: 'Bank name', bankAccountNumber: 'Bank account number', bankIFSC: 'Bank IFSC', nameAsPerBank: 'Name as per bank',
    tradersLicenseNumber: "Trader's license number", licenseExpDate: 'License expiry date',
    operatorName: 'Operator name', operatorContactNum: 'Operator contact number',
};

const VendorForm1 = ({ navigate, vendorData, onSubmit, vendor_id }) => {
    // console.log(vendorData)
    const [services, setServices] = useState([]);
    const [memberShipPlans, setMemberShipPlans] = useState([]);
    const [serviceOfferings, setServiceOfferings] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [loadingServices, setLoadingServices] = useState(true);
    const [loadingStates, setLoadingStates] = useState(true);
    const [loadingCities, setLoadingCities] = useState(true);
    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState([]);
    const [selectedCity, setSelectedCity] = useState([])
    const [serviceLocation, setServicelocation] = useState([])
    const [selectServiceName, setSelectedServiceName] = useState()
    const [servicePmLocation, setServicePMlocation] = useState([])
    const [pmLocation, setPMLocation] = useState([])

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const res = await apicall.get("country");
                setCountries(res.data);
            } catch (error) {
                console.error("Failed to fetch countries:", error);
            }
        };

        const fetchMemberShipPlan = async () => {
            try {
                const res = await apicall.get("membershipPlans");
                setMemberShipPlans(res?.data);

                // Membership is not asked for now: keep the vendor's own plan when editing, otherwise
                // always the "Standard" plan. Never fall back to "the first plan" - that is Basic.
                const plans = res?.data || [];
                const isEdit = vendor_id && vendor_id != 0;
                const ownPlan = isEdit
                    ? plans.find(x => x?.name == vendorData?.plan_name)
                    : null;
                const standard = plans.find(x => /^\s*standard\b/i.test(x?.name || ''))
                    || plans.find(x => /standard/i.test(x?.name || ''));
                const plan = ownPlan || standard;
                if (!plan && !(isEdit && vendorData?.membershipType)) {
                    toast.error('Standard membership plan was not found. Please contact the developer.');
                }
                formik.setFieldValue('membershipType', plan?.id || (isEdit ? vendorData?.membershipType : '') || '');

            } catch (error) {
                console.error("Failed to fetch services:", error);
            }
        };

        fetchCountries();
        fetchMemberShipPlan();
    }, []);
    // Services differ per country (UAE vs India), so the list follows the Contact number, the same way the order
    // form does: +91 is India (country_id 2), anything else UAE (country_id 1). The API filters by country_id.
    const [contactDial, setContactDial] = useState(() => (String(vendorData?.contactNumber || '').startsWith('91') ? '91' : '971'));
    const serviceCountryId = contactDial === '91' ? 2 : 1;
    // Encrypted id of that country, for the state/<country> call that lists its service locations.
    const serviceCountry = useMemo(
        () => countries.find(c => Number(c.country_id) === serviceCountryId),
        [countries, serviceCountryId]
    );

    useEffect(() => {
        const fetchServices = async () => {
            setLoadingServices(true);
            try {
                const res = await apicall.get(`services?country_id=${serviceCountryId}`);
                const list = res?.data || [];
                setServices(list);
                const current = formik.values.serviceType || [];
                const savedNames = vendorData?.services?.map(x => x.name) || [vendorData?.service_name];
                const fromVendor = list.filter(x => savedNames.includes(x?.name));
                // Keep the services already picked that exist in this country; when editing, start from the vendor's own.
                const keep = current.filter(id => list.some(x => x.id === id));
                formik.setFieldValue('serviceType', keep.length ? keep : fromVendor.map(x => x.id));
            } catch (error) {
                console.error("Failed to fetch services:", error);
            } finally {
                setLoadingServices(false);
            }
        };
        fetchServices();
    }, [serviceCountryId]);

    const toggleLocation = (location) => {
        const picked = formik.values.selectlocation || [];
        const next = picked.some(x => x.id === location.id)
            ? picked.filter(x => x.id !== location.id)
            : [...picked, location];
        setSelectedCity(prev => prev.map(x => (x.id === location.id ? { ...x, is_selected: !x.is_selected } : x)));
        formik.setFieldValue('selectlocation', next);
    };
    const offeringsPmLOcation = async (offering) => {
        // Create a copy of the current servicePmLocation state
        let tempArray = [...servicePmLocation]; // Use spread operator to create a new array
        offering.is_selected = !offering.is_selected; // Toggle the is_selected property

        // Find the index of the offering in the tempArray
        const index = tempArray.findIndex(x => x?.name === offering?.name);

        if (index !== -1) {
            // If the offering is already in the array, remove it
            tempArray.splice(index, 1);
        } else {
            // Otherwise, add the offering to the array
            tempArray.push(offering);
        }

        const [location1, location2] = offering.name.split("-");
        const [location1Id, location2Id] = offering.id.split(",");
        const selectedLocation = {
            location1,
            location1Id,
            location2,
            location2Id,
            is_selected: offering.is_selected
        };
        // console.log("Selected Location:", selectedLocation);
        setServicePMlocation(tempArray);
        formik.setFieldValue('selectPMlocation', tempArray);

        // console.log(tempArray, "tempArray");
    };

    const fetchStates = async (countryId) => {
        setLoadingStates(true);
        setStates([]);
        setCities([]);
        formik.setFieldValue('state', '');
        formik.setFieldValue('city', '');

        try {
            const res = await apicall.get(`state/${countryId}`);
            setStates(res.data);
            var i = res.data.findIndex(x => x.name === vendorData?.state_name);
            formik.setFieldValue('state', i != -1 ? res.data[i].id : '');
            if (i != -1) {
                fetchCities(res.data[i].id);
            }
        } catch (error) {
            console.error("Failed to fetch states:", error);
        } finally {
            setLoadingStates(false);
        }
    };
    // Service locations are the states of the contact number's country (state/<country>), not every state.
    // The vendor can pick as many as they serve.
    const fetchServiceLocations = async () => {
        if (!serviceCountry) {
            setSelectedCity([]);
            return;
        }
        try {
            const res = await apicall.get(`state/${serviceCountry.id}`);
            const saved = vendorData?.selectlocation || [];
            const list = (res.data || []).map(x => ({ ...x, is_selected: saved.some(v => v.name === x.name) }));
            setSelectedCity(list);
            formik.setFieldValue('selectlocation', list.filter(x => x.is_selected));
        } catch (error) {
            console.error("Failed to fetch locations:", error);
        }
    };
    const fetchPackersMoversLocations = async () => {
        let temp = [];
        try {
            const res = await apicall.get(`packersmoverslocations`);
            // console.log("res.data", res.data); // Log the fetched data

            for (const file of res.data) {
                file.is_selected = false;

                if (Array.isArray(vendorData?.selectPMlocation)) {
                    const index = vendorData.selectPMlocation.findIndex(x => x.name === file.name);
                    if (index !== -1) {
                        file.is_selected = true;
                        temp.push(file);
                    }
                }
            }
            setPMLocation(res.data);
            formik.setFieldValue("selectPMlocation", temp);
            setServicePMlocation(temp);
        } catch (error) {
            console.error("Failed to fetch states:", error);
        }
    };

    const fetchCities = async (stateId) => {
        setLoadingCities(true);
        setCities([]);
        formik.setFieldValue('city', '');
        try {
            const res = await apicall.get(`city/${stateId}`);
            setCities(res.data);
            var i = res.data.findIndex(x => x.name === vendorData?.city_name);
            formik.setFieldValue('city', i != -1 ? res.data[i].id : '');
        } catch (error) {
            console.error("Failed to fetch cities:", error);
        } finally {
            setLoadingCities(false);
        }
    };

    // India mobiles are 10 digits starting 6-9 (91 + that); UAE mobiles are the 9-digit 5xxxxxxxx
    // national number (971 + that). Plain "is numeric" let through junk like "0000000" or a
    // too-short "034765", since those are numeric too. The message names the exact rule for
    // whichever country the number belongs to, so the admin knows what to fix.
    function mobileTest(value) {
        const v = String(value || '');
        if (v.startsWith('91')) {
            if (/^91[6-9]\d{9}$/.test(v)) return true;
            return this.createError({ message: 'Enter a valid 10-digit India mobile number starting with 6, 7, 8 or 9' });
        }
        if (v.startsWith('971')) {
            if (/^9715\d{8}$/.test(v)) return true;
            return this.createError({ message: 'Enter a valid 9-digit UAE mobile number starting with 5' });
        }
        return this.createError({ message: 'Enter a valid India or UAE mobile number' });
    }

    const formik = useFormik({
        initialValues: {
            vendorName: vendorData?.vendorName || '',
            serviceType: [],
            contactNumber: vendorData?.contactNumber || '',
            country: '',
            state: '',
            city: '',
            email: vendorData?.email || '',
            address: vendorData?.address || '',
            membershipType: '',
            // Membership dates are not asked for now: a new vendor starts today for one year; editing keeps its own.
            membershipStartDate: vendorData?.membershipStartDate
                ? new Date(vendorData.membershipStartDate).toISOString().split('T')[0]
                : new Date().toISOString().split('T')[0],
            membershipEndDate: vendorData?.membershipEndDate
                ? new Date(vendorData.membershipEndDate).toISOString().split('T')[0]
                : new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
            bankName: vendorData?.bankName || '',
            bankAccountNumber: vendorData?.bankAccountNumber || '',
            bankIFSC: vendorData?.bankIFSC || '',
            nameAsPerBank: vendorData?.nameAsPerBank || '',
            tradersLicenseNumber: vendorData?.tradersLicenseNumber || '',
            licenseExpDate: vendorData?.licenseExpDate
                ? new Date(vendorData.licenseExpDate).toISOString().split('T')[0]
                : '',
            // Edit loads the snake_case names, coming back from the price page brings the form's own names.
            operatorName: vendorData?.operatorName ?? vendorData?.operator_name ?? '',
            operatorContactNum: vendorData?.operatorContactNum ?? vendorData?.operator_contact_number ?? '',
            serviceOffering: [],
            selectedServices: [],
            selectedNewServiceType: [],
            selectedServiceType: [],
            selectlocation: [],
            serviceLocation: [],
            selectPMlocation: [],
            servicePmLocation: [],
        },
        validationSchema: Yup.object({
            vendorName: Yup.string().required('Vendor name is required'),
            serviceType: Yup.array()
                .min(1, 'Select at least one service')
                .test('pm-alone', 'Packers & Movers has its own pricing, add it on its own', function (ids) {
                    const names = services.filter(x => (ids || []).includes(x.id)).map(x => x.name);
                    return !(names.includes('Packers & Movers') && names.length > 1);
                }),
            selectlocation: Yup.array().test('locations', 'Select at least one service location', function (v) {
                const names = services.filter(x => (this.parent.serviceType || []).includes(x.id)).map(x => x.name);
                return names.includes('Packers & Movers') || (v || []).length > 0;
            }),
            contactNumber: Yup.string()
                .required('Contact number is required')
                .test('valid-mobile', 'Enter a valid India or UAE mobile number', mobileTest),
            country: Yup.string().required('Country is required'),
            state: Yup.string().required('State is required'),
            city: Yup.string().required('City is required'),
            email: Yup.string()
                .matches(
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    'Invalid email format'
                )
                .required('Email is required'),
            address: Yup.string().required('Address is required'),
            // Membership is not asked for now (defaults are filled in above).
            // membershipType: Yup.string().required('Membership type is required'),
            // membershipStartDate: Yup.date().required('Membership start date is required').nullable(),
            // membershipEndDate: Yup.date().required('Membership end date is required').nullable()
            //     .min(Yup.ref('membershipStartDate'), 'Membership end date must be after start date'),
            bankName: Yup.string().required('Vendor’s Bank Name is required'),
            bankAccountNumber: Yup.string().required('Vendor’s Bank Account Number is required'),
            bankIFSC: Yup.string().required('Vendor’s Bank IFSC is required'),
            nameAsPerBank: Yup.string().required('Name as per the bank account is required'),
            operatorName: Yup.string().required('Operator Name is required'),
            operatorContactNum: Yup.string()
                .required('Operator contact Number is required')
                .test('valid-mobile', 'Enter a valid India or UAE mobile number', mobileTest),
            tradersLicenseNumber: Yup.string().required('Trader’s License Number is required'),
            licenseExpDate: Yup.date()
                .required('License Exp. Date is required')
                .nullable()
                .min(new Date(), 'License Exp. Date cannot be in the past'),
            // selectedServices: Yup.array().min(1, 'At least one service offering is required'),
        }),
        onSubmit: (values) => {
            try {
            const picked = services.filter(x => values.serviceType.includes(x.id));
            values.services = picked.map(x => ({ id: x.id, name: x.name }));
            values.service_name = picked[0].name;
            values.country_name = countries[countries.findIndex(c => c.id == values.country)].name;
            values.state_name = states[states.findIndex(s => s.id == values.state)].name;
            values.city_name = cities[cities.findIndex(c => c.id == values.city)].name;
            values.plan_name = memberShipPlans.find(m => m.id == values.membershipType)?.name;
            onSubmit(values);
            } catch (err) {
                console.error(err);
                toast.error(`Could not continue: ${err.message}`);
            }
            // console.log("values",values)
        },

    });
    // Name is compared with the existing vendors. Mobile and email are compared with every account
    // (vendor or customer), the same way the final save does it - the save checks the users table
    // directly, so a vendor whose self-signup left a user record without a finished vendor profile
    // (invisible to the vendor list) was slipping past this step and only failing at save, after the
    // offerings were filled in. The vendor being edited is ignored. A failed lookup never blocks the
    // form: the save still checks everything.
    const findDuplicates = async (values) => {
        const found = {};
        const isEdit = vendor_id && vendor_id != 0;
        const digits = (v) => String(v || '').replace(/\D/g, '');
        const lower = (v) => String(v || '').trim().toLowerCase();
        // Ids from the lists are encrypted differently on every call, so the vendor being edited cannot be told
        // apart by id. Instead, a value that was not changed is the vendor's own and is never a duplicate.
        const nameChanged = !isEdit || lower(values.vendorName) !== lower(vendorData?.vendorName);
        const phoneChanged = !isEdit || digits(values.contactNumber) !== digits(vendorData?.contactNumber);
        const emailChanged = !isEdit || lower(values.email) !== lower(vendorData?.email);
        if (nameChanged) {
            try {
                const res = await apicall.post({}, 'vendor_list');
                if ((res?.data || []).some((v) => lower(v.vendor_name) === lower(values.vendorName))) {
                    found.vendorName = 'A vendor with this name already exists';
                }
            } catch (e) { /* the save will check again */ }
        }
        if (phoneChanged || emailChanged) {
            // Vendor (3) and customer (4) accounts - the two roles that can already hold this mobile/email.
            const roles = [3, 4];
            const results = await Promise.all(roles.map((role) => apicall.post({
                ...(phoneChanged ? { phone_number: values.contactNumber } : {}),
                ...(emailChanged ? { email: values.email.trim() } : {}),
                role,
            }, 'checkUserExists').catch(() => null)));
            results.forEach((res) => {
                (res?.data?.users || []).forEach((u) => {
                    if (phoneChanged && digits(u.phone_number) === digits(values.contactNumber)) {
                        found.contactNumber = 'A vendor with this mobile number already exists';
                    }
                    if (emailChanged && lower(u.email) === lower(values.email)) {
                        found.email = 'A vendor with this email already exists';
                    }
                });
            });
        }
        return found;
    };

    const pickedServices = services.filter(x => (formik.values.serviceType || []).includes(x.id));
    const pmOnly = pickedServices.length === 1 && pickedServices[0].name === 'Packers & Movers';
    // The location buttons follow the contact number's country: reload them when it changes.
    useEffect(() => {
        fetchServiceLocations();
    }, [serviceCountry?.country_id]);
    // The country is the one of the contact number's code; it changes only when that code changes.
    useEffect(() => {
        if (serviceCountry && formik.values.country !== serviceCountry.id) {
            formik.setFieldValue('country', serviceCountry.id);
            fetchStates(serviceCountry.id);
        }
    }, [serviceCountry?.id]);
    useEffect(() => {
        if (pmOnly) fetchPackersMoversLocations();
    }, [pmOnly]);

    return (
        <form onSubmit={async (e) => {
            e.preventDefault();
            const errs = await formik.validateForm();
            if (Object.keys(errs).length) {
                formik.setTouched(Object.keys(errs).reduce((t, k) => ({ ...t, [k]: true }), {}), false);
                toast.error(`Please fill: ${Object.keys(errs).map((k) => FIELD_LABELS[k] || k).join(', ')}`);
                return;
            }
            // The server only rejects a duplicate name / mobile / email when the vendor is finally saved (page 2),
            // so ask for them here, while the person is still on the details they can fix.
            const dup = await findDuplicates(formik.values);
            if (Object.keys(dup).length) {
                formik.setErrors(dup);
                formik.setTouched(Object.keys(dup).reduce((t, k) => ({ ...t, [k]: true }), {}), false);
                const dupLabels = { vendorName: 'name', contactNumber: 'phone number', email: 'email' };
                const names = ['vendorName', 'contactNumber', 'email'].filter((k) => dup[k]).map((k) => dupLabels[k]);
                const list = names.length > 1 ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}` : names[0];
                const dupMsg = `A vendor with this ${list} already exists`;
                // toastId keeps the same alert from stacking up if Next is clicked again.
                toast.error(dupMsg, { toastId: 'vendor-duplicate' });
                return;
            }
            try {
                formik.submitForm();
            } catch (err) {
                toast.error(err.message);
            }
        }} className='label vf'>
            <div className="row mb-3">
                <div className="vf-title col-12">Vendor details</div>
                <div className="col">
                    <label htmlFor="vendorName" className="form-label">Vendor Name</label>
                    <input
                        type="text"
                        className={`form-control ${(formik.touched.vendorName || formik.values.vendorName) && formik.errors.vendorName ? 'is-invalid' : ''}`}
                        id="vendorName"
                        name="vendorName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.vendorName}
                    />
                    {(formik.touched.vendorName || formik.values.vendorName) && formik.errors.vendorName && (
                        <div className="invalid-feedback">{formik.errors.vendorName}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="contact" className="form-label">Contact</label>
                    <PhoneInput
                        onlyCountries={['ae', 'in']}
                        country={'ae'}
                        value={formik.values.contactNumber}
                        onChange={(value, country, e) => {
                            formik.setFieldValue('contactNumber', value);
                            const dial = String(value || '').startsWith('91') ? '91' : '971';
                            if (dial !== contactDial) {
                                setContactDial(dial);
                                // Operator number: switch to the same country code unless a full number was typed.
                                const op = String(formik.values.operatorContactNum || '');
                                if (op.length <= 5) formik.setFieldValue('operatorContactNum', dial);
                            }
                        }}
                        inputStyle={{ width: '100%' }}
                    />
                    {(formik.touched.contactNumber || formik.values.contactNumber) && formik.errors.contactNumber && (
                        <div className="text-danger mt-1">{formik.errors.contactNumber}</div>
                    )}
                </div>
            </div>
            <div className="row mb-3">
                <div className="vf-title col-12">Location</div>
                <div className="col">
                    <label htmlFor="country" className="form-label">Country</label>
                    <select
                        id="country"
                        name="country"
                        className={`form-select ${formik.touched.country && formik.errors.country ? 'is-invalid' : ''}`}
                        onChange={() => {}}
                        onBlur={formik.handleBlur}
                        value={formik.values.country}
                        disabled
                        title="The country follows the country code of the contact number"
                    >
                        <option value="">Select Country</option>
                        {countries.map(country => (
                            <option key={country.id} value={country.id}>{country.name}</option>
                        ))}
                    </select>
                    {formik.touched.country && formik.errors.country && (
                        <div className="invalid-feedback">{formik.errors.country}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="state" className="form-label">State</label>
                    <select
                        id="state"
                        name="state"
                        className={`form-select ${formik.touched.state && formik.errors.state ? 'is-invalid' : ''}`}
                        onChange={(e) => {
                            formik.handleChange(e);
                            fetchCities(e.target.value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.state}
                    >
                        <option value="">Select State</option>
                        {loadingStates ? (
                            <option>Loading states...</option>
                        ) : (
                            states.map(item => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                            ))
                        )}
                    </select>
                    {formik.touched.state && formik.errors.state && (
                        <div className="invalid-feedback">{formik.errors.state}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="city" className="form-label">City</label>
                    <select
                        id="city"
                        name="city"
                        className={`form-select ${formik.touched.city && formik.errors.city ? 'is-invalid' : ''}`}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.city}
                    >
                        <option value="">Select City</option>
                        {loadingCities ? (
                            <option>Loading cities...</option>
                        ) : (
                            cities.map(item => (
                                <option key={item.id} value={item.id}>{item.name}</option>
                            ))
                        )}
                    </select>
                    {formik.touched.city && formik.errors.city && (
                        <div className="invalid-feedback">{formik.errors.city}</div>
                    )}
                </div>
            </div>
            <div className="row mb-3 mt-3">
                <div className="vf-title col-12">Email &amp; address</div>
                <div className="col-4 ">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                        type="email"
                        className={`form-control ${(formik.touched.email || formik.values.email) && formik.errors.email ? 'is-invalid' : ''}`}
                        id="email"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                    />
                    {(formik.touched.email || formik.values.email) && formik.errors.email && (
                        <div className="invalid-feedback">{formik.errors.email}</div>
                    )}
                </div>
                <div className="col-8">
                    <label htmlFor="address" className="form-label">Address</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.address && formik.errors.address ? 'is-invalid' : ''}`}
                        id="address"
                        name="address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                    />
                    {formik.touched.address && formik.errors.address && (
                        <div className="invalid-feedback">{formik.errors.address}</div>
                    )}
                </div>
            </div>
            {/* Membership details are not needed for now:
            <div className="row mb-3">
                <div className="vf-title col-12">Membership</div>

                <div className="col">
                    <label htmlFor="membershipType" className="form-label">Membership Type</label>
                    <select
                        id="membershipType"
                        name="membershipType"
                        className={`form-select ${formik.touched.membershipType && formik.errors.membershipType ? 'is-invalid' : ''}`}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.membershipType}
                    >
                        <option value="">Select Membership Type</option>
                        {memberShipPlans.map(plan => (
                            <option key={plan.id} value={plan.id}>{plan.name}</option>
                        ))}
                    </select>
                    {formik.touched.membershipType && formik.errors.membershipType && (
                        <div className="invalid-feedback">{formik.errors.membershipType}</div>
                    )}
                </div>


                <div className="col">
                    <label htmlFor="membershipStartDate" className="form-label">Membership Start Date</label>
                    <input
                        type="date"
                        className={`form-control ${formik.touched.membershipStartDate && formik.errors.membershipStartDate ? 'is-invalid' : ''}`}
                        id="membershipStartDate"
                        name="membershipStartDate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.membershipStartDate}
                        onKeyDown={(e) => e.preventDefault()}
                    />
                    {formik.touched.membershipStartDate && formik.errors.membershipStartDate && (
                        <div className="invalid-feedback">{formik.errors.membershipStartDate}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="membershipEndDate" className="form-label">Membership End Date</label>
                    <input
                        type="date"
                        className={`form-control ${formik.touched.membershipEndDate && formik.errors.membershipEndDate ? 'is-invalid' : ''}`}
                        id="membershipEndDate"
                        name="membershipEndDate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.membershipEndDate}
                        onKeyDown={(e) => e.preventDefault()}
                    />
                    {formik.touched.membershipEndDate && formik.errors.membershipEndDate && (
                        <div className="invalid-feedback">{formik.errors.membershipEndDate}</div>
                    )}
                </div>

            </div>
            */}
            <div className="row mb-3 mt-3">
                <div className="vf-title col-12">Bank details</div>
                <div className="col">
                    <label htmlFor="bankName" className="form-label">Vendor’s Bank Name</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.bankName && formik.errors.bankName ? 'is-invalid' : ''}`}
                        id="bankName"
                        name="bankName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bankName}
                    />
                    {formik.touched.bankName && formik.errors.bankName && (
                        <div className="invalid-feedback">{formik.errors.bankName}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="bankAccountNumber" className="form-label">Vendor’s Bank Account Number</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.bankAccountNumber && formik.errors.bankAccountNumber ? 'is-invalid' : ''}`}
                        id="bankAccountNumber"
                        name="bankAccountNumber"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bankAccountNumber}
                    />
                    {formik.touched.bankAccountNumber && formik.errors.bankAccountNumber && (
                        <div className="invalid-feedback">{formik.errors.bankAccountNumber}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="bankIFSC" className="form-label">Vendor’s Bank IFSC</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.bankIFSC && formik.errors.bankIFSC ? 'is-invalid' : ''}`}
                        id="bankIFSC"
                        name="bankIFSC"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.bankIFSC}
                    />
                    {formik.touched.bankIFSC && formik.errors.bankIFSC && (
                        <div className="invalid-feedback">{formik.errors.bankIFSC}</div>
                    )}
                </div>
            </div>
            <div className="row mb-3 mt-3">
                <div className="vf-title col-12">License, operator &amp; services</div>
                <div className="col">
                    <label htmlFor="nameAsPerBank" className="form-label">Name as per the Bank Account</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.nameAsPerBank && formik.errors.nameAsPerBank ? 'is-invalid' : ''}`}
                        id="nameAsPerBank"
                        name="nameAsPerBank"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.nameAsPerBank}
                    />
                    {formik.touched.nameAsPerBank && formik.errors.nameAsPerBank && (
                        <div className="invalid-feedback">{formik.errors.nameAsPerBank}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="tradersLicenseNumber" className="form-label">Trader’s License Number</label>
                    <input
                        type="text"
                        className={`form-control ${formik.touched.tradersLicenseNumber && formik.errors.tradersLicenseNumber ? 'is-invalid' : ''}`}
                        id="tradersLicenseNumber"
                        name="tradersLicenseNumber"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.tradersLicenseNumber}
                    />
                    {formik.touched.tradersLicenseNumber && formik.errors.tradersLicenseNumber && (
                        <div className="invalid-feedback">{formik.errors.tradersLicenseNumber}</div>
                    )}
                </div>
                <div className="col">
                    <label htmlFor="licenseExpDate" className="form-label">License Exp. Date</label>
                    <input
                        type="date"
                        className={`form-control ${formik.touched.licenseExpDate && formik.errors.licenseExpDate ? 'is-invalid' : ''}`}
                        id="licenseExpDate"
                        name="licenseExpDate"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.licenseExpDate}
                        onKeyDown={(e) => e.preventDefault()}
                    />
                    {formik.touched.licenseExpDate && formik.errors.licenseExpDate && (
                        <div className="invalid-feedback">{formik.errors.licenseExpDate}</div>
                    )}
                </div>
                <div className="row mb-3 mt-3">
                    <div className="col">
                        <label htmlFor="operatorName" className="form-label">Operator Name</label>
                        <input
                            type="text"
                            className={`form-control ${formik.touched.operatorName && formik.errors.operatorName ? 'is-invalid' : ''}`}
                            id="operatorName"
                            name="operatorName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.operatorName}
                        />
                        {formik.touched.operatorName && formik.errors.operatorName && (
                            <div className="invalid-feedback">{formik.errors.operatorName}</div>
                        )}
                    </div>
                     <div className="col-md-4 mt-2">
                    <label htmlFor="operatorContactNum" className="label">Operator Contact Number</label>
                    <PhoneInput
                        key={`operator-${contactDial}`}
                        onlyCountries={[contactDial === '91' ? 'in' : 'ae']}
                        country={contactDial === '91' ? 'in' : 'ae'}
                        disableDropdown
                            value={formik.values.operatorContactNum}
                        onChange={(value, country, e) => {
                                formik.setFieldValue('operatorContactNum', value);
                            }}
                        inputStyle={{ width: '100%' }}
                    />
                     {(formik.touched.operatorContactNum || formik.values.operatorContactNum) && formik.errors.operatorContactNum && (
                            <div className="text-danger mt-1">{formik.errors.operatorContactNum}</div>
                        )}
                </div>
                   
                    <div className="col"></div>
                </div>
                <div className="row mb-3 mt-3">
                    <div className="col-12">
                        <label htmlFor="serviceType" className="form-label">Services</label>
                        <MultiSelect
                            id="serviceType"
                            value={formik.values.serviceType}
                            options={services}
                            optionLabel="name"
                            optionValue="id"
                            onChange={(e) => formik.setFieldValue('serviceType', e.value)}
                            onBlur={() => formik.setFieldTouched('serviceType', true)}
                            placeholder={loadingServices ? 'Loading services...' : 'Select Service'}
                            display="chip"
                            filter
                            className={`w-100 vf-multi ${formik.touched.serviceType && formik.errors.serviceType ? 'p-invalid' : ''}`}
                        />
                        {formik.touched.serviceType && formik.errors.serviceType && (
                            <div className="text-danger mt-1">{formik.errors.serviceType}</div>
                        )}
                    </div>
                </div>
                {pmOnly && (
                    <div className="row mb-3 mt-3">
                        <div className="col-12 mb-4">
                            <label className="label mb-3">{pmLocation.length > 0 ? `Service Locations` : ``}</label>
                            <div
                                className="d-flex overflow-auto"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                {pmLocation.length > 0 &&
                                    pmLocation.map((service, index) => (
                                        <button
                                            key={index}
                                            type="button"
                                            onClick={() => offeringsPmLOcation(service)}
                                            className={`btn mx-2 btn-outline-secondary text-dark ${service.is_selected ? 'primaryBackground text-white' : ''}`}
                                        >
                                            {service.name}
                                        </button>
                                    ))}
                            </div>
                            {formik.touched.servicePmLocation && formik.errors.servicePmLocation && (
                                <div className="invalid-feedback d-block mx-2 mt-2">{formik.errors.servicePmLocation}</div>
                            )}
                        </div>
                    </div>
                )}
                {!pmOnly && (
                    <div className="row mb-3 mt-3">
                        <div className="col-12 mb-2">
                            <label className="label mb-2">Service Locations (select every location the vendor serves)</label>
                            <div className="d-flex overflow-auto" style={{ whiteSpace: "nowrap" }}>
                                {selectedCity.length === 0 && <span className="label">{serviceCountry ? 'No locations found' : 'Loading locations...'}</span>}
                                {selectedCity.map((location) => (
                                    <button
                                        key={location.id}
                                        type="button"
                                        className={`btn mx-2 btn-outline-secondary text-dark ${location.is_selected ? 'primaryBackground text-white' : ''}`}
                                        onClick={() => toggleLocation(location)}
                                    >
                                        {location.name}
                                    </button>
                                ))}
                            </div>
                            {formik.touched.selectlocation && formik.errors.selectlocation && (
                                <div className="text-danger mt-1">{formik.errors.selectlocation}</div>
                            )}
                        </div>
                    </div>
                )}

            </div>

            <div className='vf-actions d-flex justify-content-center mt-4 mb-2'>

                <button
                    type="button"
                    className="btn Button primaryColorText btn-outline-secondary me-2 no-hover-effect"
                    onClick={() => navigate('/vendors')}
                >
                    Cancel
                </button>
                <button type="submit" className="btn Button primaryBackground text-white position-relative d-flex justify-content-center align-items-center">Next</button>
            </div>

        </form>
    );
};

export default VendorForm1;